import { useConfigFlag } from "@cloudbreakus/featurebang-react"
import {
  MULTI_PATIENT_REFRESH_INTERVAL_SECONDS,
  MULTI_PATIENT_REFRESH_INTERVAL_SECONDS_DEFAULT,
  MULTI_PATIENT_LISTEN_IN_REFRESH_INTERVAL_SECONDS,
  MULTI_PATIENT_LISTEN_IN_REFRESH_INTERVAL_SECONDS_DEFAULT,
} from "constants/featureFlags"

export const useMultiPatientRefreshInterval = ({ listeningIn }) => {
  const regularSeconds = useConfigFlag(MULTI_PATIENT_REFRESH_INTERVAL_SECONDS, MULTI_PATIENT_REFRESH_INTERVAL_SECONDS_DEFAULT)
  const listenInSeconds = useConfigFlag(
    MULTI_PATIENT_LISTEN_IN_REFRESH_INTERVAL_SECONDS,
    MULTI_PATIENT_LISTEN_IN_REFRESH_INTERVAL_SECONDS_DEFAULT
  )
  if (listeningIn) return listenInSeconds
  return regularSeconds
}
